import { alpha, Button, styled } from '@mui/material'

export const StyledUserOptionsButton = styled(Button)(({ theme }) => {
  // @ts-ignore
  const buttonColor = theme.palette.background.user.action
  const buttonTextColor = theme.palette.grey[400]

  return {
    position: 'absolute',
    top: 0,
    right: 0,
    margin: theme.spacing(0.5),
    padding: theme.spacing(0.25),
    boxShadow: theme.shadows[2],
    minWidth: 0,
    zIndex: 10,
    color: buttonTextColor,

    background: buttonColor,
    '&:hover': {
      background: alpha(buttonColor, 0.7),
    },
  }
})
